// @flow

import type {Company} from '@/types'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {formActions, portfoliosSelectors} from '@/store'
import {isNumber, validateObject} from '@/validation'
import EditField from '@/controls/edit-field'

type Props = {
  id: string,
  companies: {[string]: Company},
  setFormData: (any) => void,
}

const validators = {
  personalLimit: [isNumber('Limit')],
}

export class RawEditCompanyForm extends Component<Props, *> {
  constructor (props: Props) {
    super(props)

    const data = props.companies[props.id]
    const fields = {
      name: data.name,
      personalReference: data.personalReference,
      personalLimit: data.personalLimit,
      freeText: data.freeText,
    }
    this.state = fields
  }

  update = (key: string) => (value: any) => {
    this.setState({
      [key]: value,
    }, () => {
      validateObject(validators, this.state)
        .fold(
          () => this.props.setFormData(null),
          this.props.setFormData
        )
    })
  }

  render = () =>
    <div>
      <h4>{this.state.name}</h4>
      <div className="row">
        <div className="col-xs-4">
          <EditField
            label="Reference"
            defaultValue={this.state.personalReference}
            onChange={this.update('personalReference')}
          />
        </div>
        <div className="col-xs-4">
          <EditField
            label="Limit"
            defaultValue={this.state.personalLimit}
            onChange={this.update('personalLimit')}
            validators={validators['personalLimit']}
          />
        </div>
        <div className="col-xs-4">
          <EditField
            label="Notes"
            defaultValue={this.state.freeText}
            onChange={this.update('freeText')}
          />
        </div>
      </div>
    </div>
}

const mapStateToProps = (state, {id}) => ({
  companies: portfoliosSelectors.getActivePortfolioCompaniesMap(state),
})

const mapDispatchToProps = (dispatch) => ({
  setFormData: (data: any) => dispatch(formActions.setFormData(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RawEditCompanyForm)



// WEBPACK FOOTER //
// ./src/views/forms/edit-company.js